var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIconAb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78809 19.2348C8.78809 18.0695 9.25102 16.9518 10.0751 16.1278C10.8991 15.3038 12.0167 14.8408 13.1821 14.8408H43.9401C45.1054 14.8408 46.2231 15.3038 47.0471 16.1278C47.8711 16.9518 48.3341 18.0695 48.3341 19.2348V41.2048C48.3341 42.3702 47.8711 43.4878 47.0471 44.3118C46.2231 45.1359 45.1054 45.5988 43.9401 45.5988H13.1821C12.0167 45.5988 10.8991 45.1359 10.0751 44.3118C9.25102 43.4878 8.78809 42.3702 8.78809 41.2048V19.2348Z",
    stroke: "white",
    strokeWidth: 4.394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78809 19.2344L28.5611 32.4164L48.3341 19.2344",
    stroke: "white",
    strokeWidth: 4.394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconAb);
export default __webpack_public_path__ + "static/media/mailIcon_ab.ec6eb3ce94137512943c49ed849af95c.svg";
export { ForwardRef as ReactComponent };